import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { PipelineService } from 'src/app/pipeline/pipeline.service';
import { ProjetcsService } from 'src/app/projects/projetcs.service';
import { BackgroundFilesService, IPendingFile } from '../../services/background-files.service';
import { GlobalService } from '../../services/global.service';

@Component({
    selector: 'app-add-project',
    templateUrl: './add-project.component.html',
    styleUrls: ['./add-project.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddProjectComponent implements OnInit {

	@ViewChild('form', { static: false }) form: NgForm;
	@Input() project: any;
	@Output() closeView = new EventEmitter<string>();
	@Output() notify = new EventEmitter<string>();

	loading: boolean = true;
	viewData: any;
	selectedFile: any[] = [];
	formData: any = {
		'img': '',
		'type': '',
		'status': '',
		'category': '',
		'productionCountry': '',
		'name': '',
		'abbr': '',
		'abbreviation_edl': '',
		'season': '',
		'episodes': '',
		'duration': '',
		'pre_production_start': '',
		'weeks_pre_production': '',
		'pre_production_end': '',
		'production_start': '',
		'weeks_production': '',
		'production_end': '',
		'pos_production_start': '',
		'weeks_pos_production': '',
		'pos_production_end': '',
		'list_shooting_config_time': []
	};

	submitForm() {
		this.loading = true;
		this.formData.list_shooting_config_time = this.formData.list_shooting_config_time.map(sho => sho.id);
		this._pLS.createProject(this.formData).subscribe(
			data => {
				var rdata: any = data;
				if (rdata.error == false) {
					this.selectedFile.length ? this.sendImages(rdata.project_id) : this.notify.emit();
				} else {
					this.loading = false;
				}
			}
		)
	}

	sendImages(prodId) {
		let pendingFile: IPendingFile = {
			'fileName': this.selectedFile[0].name,
			'action': 'view',
			'taskId': Date.now() + Math.random(),
			'status': 'pending',
		};
		this._bgFile.addPendingFile(pendingFile);

		this._pS.addImageToProject(this.selectedFile[0], prodId).subscribe(
			data => {
				this._bgFile.changeStatusFile(pendingFile, 'complete');
				this.notify.emit();
			},
			err => {
				console.log("Error uploading file", err);
				this._bgFile.changeStatusFile(pendingFile, 'failed');
				this.loading = false;
				this.notify.emit();
			}
		)
	}

	onChangeType() {
		if (this.formData.type == 2) {
			this.formData.season = null;
			this.formData.episodes = null;
			return;
		}
	}

	close() {
		this.closeView.emit();
	}

	sendFiles(ev) {
		this.selectedFile = ev;
	}

	calculateEndDates(itemWeeks, itemDate, itemEndDate) {
		if (!this.formData[itemWeeks] || !this.formData[itemDate]) {
			this.formData[itemEndDate] = '';
			this._gS.updateTreeValidity(this.form.form);
			return
		};

		let dateEnd = this._gS.getPreviousMonday(this.formData[itemDate]);
		let weeks = this.formData[itemWeeks];
		// Adds number of weeks
		dateEnd.setDate(dateEnd.getDate() + weeks * 7);
		// Goes to previous sunday
		dateEnd.setDate(dateEnd.getDate() - 1);
		this.formData[itemEndDate] = this._dP.transform(dateEnd, 'yyyy-MM-dd');
		this._gS.updateTreeValidity(this.form.form)
	}

	fillForm() {
		this.formData = {
			'id': this.project.id ? this.project.id : '',
			'name': this.project.title ? this.project.title : '',
			'status': this.project.project_status_id ? this.project.project_status_id.toString() : '',
			'type': this.project.project_type_id ? this.project.project_type_id.toString() : '',
			'category': this.project.project_category_id ? this.project.project_category_id.toString() : '',
			'episodes': this.project.number_episodes ? this.project.number_episodes.toString() : '',
			'duration': this.project.minutes_per_episode ? this.project.minutes_per_episode.toString() : '',
			'daily_scenes': this.project.daily_scenes ? this.project.daily_scenes.toString() : '',
			'genre': this.project.genre_id ? this.project.genre_id.toString() : '',
			'abbr': this.project.abbr ? this.project.abbr.toString() : '',
			'abbreviation_edl': this.project.abbreviation_edl ? this.project.abbreviation_edl.toString() : '',
			'weeks_pre_production': this.project.weeks_pre_production ? this.project.weeks_pre_production : '',
			'weeks_production': this.project.weeks_production ? this.project.weeks_production : '',
			'weeks_pos_production': this.project.weeks_pos_production ? this.project.weeks_pos_production : '',
			// 'productionCountry':this.getProductionCenter(this.project),
			'productionCountry': this.project.production_center_id,
			'productionPointPerson': '',
			'developPointPerson': '',
			'synopsis': this.project.synopsis ? this.project.synopsis.toString() : '',
			'budget': this.project.budget_per_episode ? this.project.budget_per_episode.toString() : '',
			'pre_production_start': this.project.pre_production_start ? this.project.pre_production_start.toString() : '',
			'production_start': this.project.production_start ? this.project.production_start.toString() : '',
			'production_end': this.project.production_end ? this.project.production_end.toString() : '',
			'first_episode_completed': this.project.first_episode_completed_tentative ? this.project.first_episode_completed_tentative.toString() : '',
			'half_completed': this.project.half_completed_tentative ? this.project.half_completed_tentative.toString() : '',
			'completed': this.project.completed_tentative_date ? this.project.completed_tentative_date.toString() : '',
			'potencials': [],
			'tentatives': [],
			'writters': [],
			'directors': [],
			'pitches': [],
			'steps': [],
			'comments': [],
			'pos_production_start': this.project.pos_production_start ? this.project.pos_production_start : '',
			'list_shooting_config_time': []
		}
		this.project.project_config_times.map((x: any) => x.id = x.shooting_config_type_id);
		this.formData.list_shooting_config_time = this.project.project_config_times;
	}

	constructor(
		private _gS: GlobalService,
		private _pLS: PipelineService,
		private _bgFile: BackgroundFilesService,
		private _dP: DatePipe,
		private _pS: ProjetcsService) { }

	ngOnInit(): void {
		this._pLS.getData().subscribe(
			data => {
				this.viewData = data;
				if (this.project) {
					this.fillForm();
				}
				this.loading = false;
			}
		)
	}

}
